import { Models } from "@hex-insights/app-modules";
import { stringToLocalDate } from "@hex-insights/core";
import { Newsletter } from "../../../Utilities";

// Note: the functions defined in this file can be passed to model field components for consistent formatting.

/**
 * Formats the title field of the Newsletter model.
 */
export function title(value: Newsletter["title"]): string {
	return Models.toString(value);
}

/**
 * Formats the imageURL field of the Newsletter model.
 */
export function imageURL(value: Newsletter["imageURL"]): string {
	return Models.toString(value);
}

/**
 * Formats the body field of the Newsletter model.
 */
export function body(value: Newsletter["body"]): string {
	return Models.toString(value);
}

/**
 * Formats the releaseAt field of the Newsletter model.
 */
export function releaseAt(value: Newsletter["releaseAt"] | null): string {
	if (value === null) {
		return "No release time set";
	}
	return stringToLocalDate(value, "second").toLocaleString(undefined, {
		year: "numeric",
		month: "long",
		day: "numeric",
		hour: "numeric",
		minute: "2-digit",
	});
}
